<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Stores' : 'Deleted Stores'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  @click="showCreateDialog = true"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="seller"
                    v-model="filter.user_id"
                    :items="sellers"
                    label="Seller"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-account"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="stores.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="500"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Image</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Address</th>
                      <th class="text-left">Country</th>
                      <th class="text-left">State</th>
                      <th class="text-left">City</th>
                      <th class="text-left">pin_code</th>
                      <th class="text-left">Seller</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="stores.length != 0">
                    <tr v-for="(store, i) in stores" :key="`store${i}`">
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="store.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Store is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="store.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Store is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-avatar v-if="store.image_path">
                          <img
                            :src="`${mediaUrl + store.image_path}`"
                            alt="Store"
                          />
                        </v-avatar>
                        <v-icon v-else>mdi-store</v-icon>
                      </td>
                      <td>{{ store.name || "" }}</td>
                      <td>{{ store.address || "" }}</td>
                      <td>{{ store.country ? store.country.description : "" }}</td>
                      <td>{{ store.state ? store.state.description : "" }}</td>
                      <td>{{ store.city ? store.city.description : "" }}</td>
                      <td>{{ store.pin_code || "" }}</td>
                      <td>
                        {{
                          store.seller
                            ? store.seller.first_name +
                              " " +
                              store.seller.last_name
                            : ""
                        }}
                      </td>

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="askDelete(store)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this store</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                @click="openEditDialog(store)"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this store</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(store.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this store</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_store" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_store = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_store" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_store = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Delete confirmation -->
    <ConfirmationDialog
      :show.sync="deleteDialog"
      title="Delete Store"
      message="This action cannot be undone."
      icon="mdi-delete"
      color="error"
      :loading="delete_store"
      @confirm="Delete_this(pendingDeleteId)"
    >
      <template v-slot:details>
        <v-alert v-if="pendingDeleteStore" outlined color="error" class="mt-3 mb-0" dense>
          <div class="d-flex align-center">
            <v-avatar size="40" class="mr-3">
              <img v-if="pendingDeleteStore.image_path" :src="`${mediaUrl}${pendingDeleteStore.image_path}`" alt="Store" />
              <v-icon v-else color="error">mdi-store</v-icon>
            </v-avatar>
            <div>
              <div class="font-weight-bold">
                {{ pendingDeleteStore.name || "Untitled store" }}
              </div>
              <div class="text-caption grey--text text--darken-1">
                {{ pendingDeleteStore.address || "No address" }}
              </div>
            </div>
          </div>
        </v-alert>
      </template>
    </ConfirmationDialog>

    <!-- Add Store -->
    <AppDialog
      :show.sync="showCreateDialog"
      max-width="900"
      persistent
      icon="mdi-store-outline"
      title="Add Store"
      subtitle="Create a new physical store location"
    >
      <StoreCreatePage
        v-if="showCreateDialog"
        embedded
        @created="onStoreCreated"
        @close="showCreateDialog = false"
      />
    </AppDialog>

    <!-- Edit Store -->
    <AppDialog
      :show.sync="showEditDialog"
      max-width="900"
      persistent
      icon="mdi-store-outline"
      title="Edit Store"
      subtitle="Update this store's details"
    >
      <StoreEditPage
        v-if="showEditDialog"
        embedded
        :store-id="editingId"
        @saved="onStoreUpdated"
        @close="showEditDialog = false"
      />
    </AppDialog>
  </v-main>
</template>

<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import AppDialog from "@/components/AppDialog.vue";
import StoreCreatePage from "./create.vue";
import StoreEditPage from "./id.vue";
export default {
  name: "storesPage",
  components: { ConfirmationDialog, AppDialog, StoreCreatePage, StoreEditPage },
  data() {
    return {
      filter: {
        is_active: "",
        user_id: "",
        show_deleted: false,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_store: false,
      restore_store: false,
      is_restored_store: false,
      showCreateDialog: false,
      showEditDialog: false,
      editingId: null,
      pendingDeleteStore: null,
      stores: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      sellers: [
        {
          id: 0,
          text: "Select Seller",
          value: "",
        },
      ],
      isLoading: false,
      isExcelloading: false,
      delete_store: false,
      deleteDialog: false,
      pendingDeleteId: null,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=store`)
        .then((masters) => {
          masters = masters.data;
          //Sellers - only users with SELLER position
          if (masters.sellers) {
            masters.sellers.forEach((seller) => {
              this.sellers.push({
                id: seller.id,
                text: seller.first_name + " " + seller.last_name,
                value: seller.id,
              });
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&user_id=" +
        this.filter.user_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`stores?${query}`)
        .then((response) => {
          this.stores = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    askDelete(store) {
      this.pendingDeleteId = store.id;
      this.pendingDeleteStore = store;
      this.deleteDialog = true;
    },
    onStoreCreated() {
      this.showCreateDialog = false;
      this.page = 1;
      this.getData();
    },
    openEditDialog(store) {
      this.editingId = this.encryptIt(store.id);
      this.showEditDialog = true;
    },
    onStoreUpdated() {
      this.showEditDialog = false;
      this.getData();
    },
    async Delete_this(id) {
      this.delete_store = true;
      await axios
        .post(`/stores/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_store = true;
          this.deleteDialog = false;
          this.pendingDeleteStore = null;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.delete_store = false;
        });
    },
    async generateExcel() {
      this.isExcelloading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      let query =
        "is_active=" +
        this.filter.is_active +
        "&user_id=" +
        this.filter.user_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      try {
        const response = await axios.get(`/stores/excel?${query}`, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `stores_${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log(error);
      }
      this.isExcelloading = false;
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    async Restore_this(id) {
      this.restore_store = true;
      await axios
        .post(`/stores/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_store = false;
          this.is_restored_store = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
